<template>
  <div :class="$attrs.class">
    <header class="header-nav">
      <!-- 左侧区域 (10%) -->
      <div class="left-section">
        <div v-if="isHomePage" class="menu-icon" @touchstart="startLongPress" @touchend="cancelLongPress" @touchmove="cancelLongPress">
          <img src="@/assets/DV-logo-w.png" alt="logo" class="logo-img-w" />
          <img src="@/assets/DV-logo.png" alt="logo" class="logo-img" />
        </div>
        <div v-else class="back-button" @click="handleBack">
          <span class="back-icon">←</span>
          <span class="back-text">返回</span>
        </div>
      </div>

      <!-- 搜索区域 (60%) -->
      <div class="search-container">
        <div class="search-box" @click="handleSearchClick">
          <i class="search-icon">🔍</i>
          <input
            type="text"
            class="search-input"
            placeholder="搜索"
            readonly
          />
        </div>
      </div>

      <!-- 右侧区域 (20%) -->
      <div class="right-section">
        <div class="follow-button" @click="goPublicNotice">公示</div>
      </div>

    </header>
  </div>
</template>

<script>
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";

export default {
  name: "HeaderNav",
  mounted() {
    this.loadBaiduAnalytics();
  },
  methods: {
    loadBaiduAnalytics() {
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?20331b59e8696816b0574c7e06e43b4b";
      hm.setAttribute("data-cookieconsent", "statistics");
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    },
    // 左上角DV·logo的长按事件，仅用于一些测试的场景
    startLongPress() {
      // alert('长按事件触发');
      this.longPressTimer = setTimeout(() => {
        // 检查是否在小程序环境中
        console.log('环境检测：', window.wx);
        if (window.wx && window.wx.miniProgram) {
          console.log('小程序环境');
          // 订阅场景标识，此标识与 模板的请求代码（template_code）一样
          const scene = 'activity';
          
          // 当前H5页面URL（用于订阅后返回）
          const currentUrl = encodeURIComponent(window.location.href);
          
          // 跳转到小程序订阅页面
          wx.miniProgram.navigateTo({
            url: `/pages/subscribe/subscribe?scene=${scene}&redirect=${currentUrl}`
          });
        } else {
          console.log('非小程序环境');
          // 非小程序环境下保持原有跳转逻辑
          this.$router.push('/action');
        }
      }, this.longPressDuration);
    },
    cancelLongPress() {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer)
        this.longPressTimer = null
      }
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    // 检查是否在首页
    const isHomePage = computed(() => {
      return route.name === "Home";
    });

    // 处理返回按钮点击事件
    const handleBack = () => {
      router.back();
    };

    // 处理搜索框点击事件
    const handleSearchClick = () => {
      // 路由名称不变，只需确保 router 配置正确
      router.push({ name: 'ProductSearch' });
    };

    // 跳转到公示页
    const goPublicNotice = () => {
      router.push({ name: 'PublicNotice' });
    };

    return {
      isHomePage,
      handleBack,
      handleSearchClick,
      goPublicNotice,
    };
  },
  data() {
    return {
      longPressTimer: null,
      longPressDuration: 1000, // 长按时间阈值，单位毫秒
    }
  },
  beforeDestroy() {
    this.cancelLongPress()
  }
};
</script>

<style lang="scss" scoped>
.header-nav {
  height: 44px;
  background-color: #ff4444;
  width: 100%;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.left-section {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* src/components/HeaderNav.vue */
.logo-img {
  z-index: 3;
  height: 24px;
  width: auto;
  position: absolute; /* 设置绝对定位 */
  animation: fadeInOut 5s ease-in-out infinite; /* 添加淡入动画 */
  // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3); /* 添加阴影 */
  // transition: transform 0.3s; /* 添加过渡效果 */
}
.logo-img-w {
  z-index: 2;
  height: 26px;
  width: auto;
  position: absolute; /* 设置绝对定位 */
  // margin-top: 1px;
  margin-left: -1px;
  opacity: 0.8;
  // animation: fadeInOut 5s ease-in-out infinite; /* 添加淡入动画 */
  // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3); /* 添加阴影 */
  // transition: transform 0.3s; /* 添加过渡效果 */
}

// .circle {
//   z-index: 1;
//   width: 36x;           /* 圆的直径 */
//   height: 36px;          /* 圆的直径 */
//   background-color: white; /* 圆的颜色 */
//   border-radius: 50%;    /* 使其成为圆形 */
//   margin-top: 2px;       /* 圆与 logo 之间的间距 */
//   margin-left: -9px;
//   opacity: 0.9;
// }

/* 定义动画 */
@keyframes fadeInOut {
  0% {
    opacity: 0.5; /* 开始时完全透明 */
  }
  50% {
    opacity: 1; /* 中间时完全不透明 */
  }
  100% {
    opacity: 0.5; /* 结束时再次完全透明 */
  }
}

.menu-icon {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.back-button {
  display: flex;
  align-items: center;
  color: #fff;
  cursor: pointer;
  font-size: 14px;

  .back-icon {
    font-size: 18px;
    margin-right: 2px;
  }
}

.search-container {
  width: 60%;
  height: 34px;
  padding: 0 10px;
  box-sizing: border-box;
}

.search-box {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 17px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  cursor: pointer;
}

.search-icon {
  font-size: 14px;
  color: #999;
  margin-right: 8px;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #333;
  background: transparent;
  height: 100%;
  cursor: pointer;

  &::placeholder {
    color: #999;
  }
}

.right-section {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.follow-button {
  color: #fff;
  font-size: 14px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 15px;
  border-radius: 17px;
  border: 1px solid rgba(255, 255, 255, 0.8);
}
</style>
